import { gql } from '@apollo/client';

export const QUERY_ELEVES_WITH_QUIZ_TO_NTE_AND_QUIZ = gql`
  query getElevesWithQuizToNotesAndQuiz($id: ID!, $quizId: ID!) {
    classe(id: $id) {
      data {
        attributes {
          users(sort: "lastname:asc") {
            data {
              attributes {
                username
                firstname
                lastname
                quiztonotes {
                  data {
                    attributes {
                      quiz {
                        data {
                          id
                        }
                      }
                      note
                      responses
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    quiz(id: $quizId) {
      data {
        id
        attributes {
          name
          desc
          competences {
            data {
              attributes {
                name
              }
            }
          }
          questions {
            data {
              id
              attributes {
                name
              }
            }
          }
        }
      }
    }
  }
`;
